import Paper from "@material-ui/core/esm/Paper";
import Box from "@material-ui/core/esm/Box";
import ChevronRight from "@material-ui/icons/esm/ChevronRight";
import Add from "@material-ui/icons/esm/Add";
import Remove from "@material-ui/icons/esm/Remove";
import Redo from "@material-ui/icons/esm/Redo";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Divider from 'components/Divider/Divider';
import { Header, LargeHeader, Subtitle, BoldSubtitle } from 'components/Text';
import { GJENSIDIGE_LINK_GENERAL, REDGO_LINK } from 'constants/urls';
import UnpaidOverview from 'modules/Overview/UnpaidOverview';
import { INVOICES } from 'routes/invoices/paths';
import { AGREEMENTS } from 'routes/overview/paths';
import { REGISTER_VEHICLE_NEW } from 'routes/overview/RegisterVehicle/paths';
import { TRANSFER } from 'routes/overview/TransferTag/paths';
import { UNREGISTER } from 'routes/overview/UnregisterTag/paths';
import BilistaAd from './BilistaAd/BilistaAd';
import OverviewCard from './OverviewCard';
import useStyles from './styles';
const imgCard2 = require('./images/car4.jpg');
const imgCard3 = require('./images/computerTyping1.jpg');
const gjensidigeAd = require('./images/gjensidige_ad.jpg');
const gjensidigeLogo = require('./images/gjensidige_logo.svg');
const redgoAd = require('./images/redgo_ad.jpg');
const redgoLogo = require('./images/redgo_logo.svg');
export default function Home() {
  const {
    t
  } = useTranslation();
  const {
    cardContainer,
    actionsRoot,
    icon,
    box,
    chevron,
    benefitAd,
    logo
  } = useStyles();
  const {
    push
  } = useHistory();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LargeHeader, null, t('home.welcome')), /*#__PURE__*/React.createElement(Header, null, t('home.actions')), /*#__PURE__*/React.createElement(Paper, {
    variant: "outlined",
    className: actionsRoot,
    onClick: () => push(TRANSFER)
  }, /*#__PURE__*/React.createElement(Redo, {
    className: icon
  }), /*#__PURE__*/React.createElement(Box, {
    className: box
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    component: "h3",
    align: "left"
  }, t('agreements.transfer_a_tag')), /*#__PURE__*/React.createElement(Subtitle, {
    component: "h3"
  }, t('agreements.transfer_a_tag_info'))), /*#__PURE__*/React.createElement(ChevronRight, {
    className: chevron
  })), /*#__PURE__*/React.createElement(Paper, {
    variant: "outlined",
    className: actionsRoot,
    onClick: () => push(REGISTER_VEHICLE_NEW)
  }, /*#__PURE__*/React.createElement(Add, {
    className: icon
  }), /*#__PURE__*/React.createElement(Box, {
    className: box
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    component: "h3",
    align: "left"
  }, t('agreements.register_new_vehicle')), /*#__PURE__*/React.createElement(Subtitle, {
    component: "h3"
  }, t('agreements.register_new_vehicle_info'))), /*#__PURE__*/React.createElement(ChevronRight, {
    className: chevron
  })), /*#__PURE__*/React.createElement(Paper, {
    variant: "outlined",
    className: actionsRoot,
    onClick: () => push(UNREGISTER)
  }, /*#__PURE__*/React.createElement(Remove, {
    className: icon
  }), /*#__PURE__*/React.createElement(Box, {
    className: box
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    component: "h3",
    align: "left"
  }, t('unregister_vehicle.remove_vehicle')), /*#__PURE__*/React.createElement(Subtitle, {
    component: "h3"
  }, t('unregister_vehicle.choose_vehicle'))), /*#__PURE__*/React.createElement(ChevronRight, {
    className: chevron
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Header, null, t('home.overviews')), /*#__PURE__*/React.createElement("div", {
    className: cardContainer
  }, /*#__PURE__*/React.createElement(OverviewCard, {
    imgSrc: imgCard2,
    label: t('agreements.agreements'),
    linkHref: AGREEMENTS
  }), /*#__PURE__*/React.createElement(OverviewCard, {
    imgSrc: imgCard3,
    label: t('invoices.invoices'),
    linkHref: INVOICES
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Header, null, t('home.flyt_benefits')), /*#__PURE__*/React.createElement("div", {
    className: cardContainer
  }, /*#__PURE__*/React.createElement(OverviewCard, {
    imgSrc: gjensidigeAd,
    label: t('home.gjensidige_car_insurance'),
    linkHref: GJENSIDIGE_LINK_GENERAL,
    logo: /*#__PURE__*/React.createElement("img", {
      src: gjensidigeLogo,
      className: logo,
      style: {
        height: '40px',
        width: 'auto'
      }
    }),
    classNames: [benefitAd]
  }), /*#__PURE__*/React.createElement(OverviewCard, {
    imgSrc: redgoAd,
    label: t('home.redgo_membership'),
    linkHref: REDGO_LINK,
    logo: /*#__PURE__*/React.createElement("img", {
      src: redgoLogo,
      className: logo,
      style: {
        height: '22px',
        width: 'auto'
      }
    }),
    classNames: [benefitAd]
  })), /*#__PURE__*/React.createElement(Box, {
    mt: 8
  }, /*#__PURE__*/React.createElement(Header, {
    hasNoSpacing: true
  }, t('home.bilista_ad_header')), /*#__PURE__*/React.createElement(BilistaAd, null)), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(UnpaidOverview, null));
}